import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from "sweetalert2";

const Banner = () => {
  // Estados
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bannerName, setBannerName] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [imageUrlInput, setImageUrlInput] = useState('');
  const [banners, setBanners] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isStatic, setIsStatic] = useState(false);

  const itemsperpage = 3;

  // Abrir modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Cerrar modal
  const closeModal = () => {
    setIsModalOpen(false);

    // Reset estados
    setBannerName('');
    setImageUrl('');
    setImageUrlInput('');
    setIsStatic(false);
  };


  // Cloudinary
  const handleImageUpload = () => {
    const widget = window.cloudinary.createUploadWidget(
      {
        cloudName: 'dyrag1fir',
        uploadPreset: 'Solticket',
        sources: ['local', 'url', 'camera'],
        showAdvancedOptions: true,
        cropping: true,
        multiple: false,
        folder: 'shows',
      },
      (error, result) => {
        if (error) {
          console.error('❌ Error Cloudinary:', error);
          return;
        }

        if (result && result.event === 'success') {
         

          setImageUrl(result.info.secure_url);
        }
      }
    );

    widget.open();
  };

  // Helpers
const isUrl = (value) => {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};

const isValidName = (value) => {
  const v = value.trim();

  if (!v) return false;

  // no puede ser URL
  if (isUrl(v)) return false;

  // letras (may/min), números y espacios
  const regex = /^[a-zA-Z0-9 ]+$/;
  if (!regex.test(v)) return false;

  return true;
};

const isValidImageUrl = (value) => {
  const v = value.trim();

  if (!v) return false;

  try {
    const url = new URL(v);

    // opcional: restringir protocolos válidos
    if (!["http:", "https:"].includes(url.protocol)) return false;

    return true;
  } catch {
    return false;
  }
};

// Crear banner
const handleSubmit = async (e) => {
  e.preventDefault();

  const name = bannerName.trim();
  const finalImageUrl = (imageUrl || imageUrlInput).trim();

 

  // 🔴 Validación: campos vacíos
  if (!name || !finalImageUrl) {
    Swal.fire({
      icon: "warning",
      title: "Campos incompletos",
      text: "Por favor, ingresa un nombre y una imagen.",
    });
    return;
  }

  // 🔴 Validación: nombre inválido
  if (!isValidName(name)) {
    Swal.fire({
      icon: "error",
      title: "Nombre inválido",
      text: "El nombre del banner no puede ser una URL ni contener enlaces.",
    });
    return;
  }

  // 🔴 Validación: URL de imagen inválida
  if (!isValidImageUrl(finalImageUrl)) {
    Swal.fire({
      icon: "error",
      title: "URL inválida",
      text: "La URL de la imagen no es válida.",
    });
    return;
  }

  try {
    const response = await axios.post("/banners/", {
      name,
      url: finalImageUrl,
      static: isStatic,
    });

   

    Swal.fire({
      icon: "success",
      title: "Banner creado",
      text: "El banner se guardó correctamente.",
      timer: 1500,
      showConfirmButton: false,
    });

    fetchBanners();
    closeModal();
  } catch (error) {
    console.error("❌ Error al crear banner");

    let message = "Error de red o servidor";

    if (error.response) {
      console.error("STATUS:", error.response.status);
      console.error("DATA:", error.response.data);

      message = error.response.data?.message || "Error al crear banner";
    }

    Swal.fire({
      icon: "error",
      title: "Error",
      text: message,
    });
  }
};

  // Obtener banners
  const fetchBanners = async () => {
    try {
      const response = await axios.get('/banners/');

      

      const dynamicBanners = (response.data.bannerArray || []).map(b => ({
        ...b,
        static: false
      }));

      const staticBanners = (response.data.staticArray || []).map(b => ({
        ...b,
        static: true
      }));

      // 🔥 unir ambos arrays
      const allBanners = [...dynamicBanners, ...staticBanners];

     
      setBanners(allBanners);

      setTotalPages(
        Math.ceil(allBanners.length / itemsperpage)
      );

    } catch (error) {
      console.error('❌ Error al obtener los banners:', error);
    }
  };

 const handleDelete = async (name, isStatic) => {
  try {
   
    await axios.delete(`/banners/${name}/${isStatic}`);

  
    fetchBanners();

  } catch (error) {
    console.error("❌ Error al eliminar banner");

    if (error.response) {
      console.error("STATUS:", error.response.status);
      console.error("DATA:", error.response.data);
    } else {
      console.error(error);
    }
  }
};

  // Cambiar página
  const changePage = (page) => {
    if (page < 1 || page > totalPages) return;

    setCurrentPage(page);
  };

  // Cargar banners
  useEffect(() => {
    fetchBanners();
  }, []);

  // Paginación
  const getCurrentPageBanners = () => {
    const startIndex = (currentPage - 1) * itemsperpage;
    const endIndex = startIndex + itemsperpage;

    return banners.slice(startIndex, endIndex);
  };

  return (
    <div
      className="
        min-h-screen
        flex flex-col
        items-center
        pt-[250px]
        px-4
        md:px-6
        max-w-screen-xl
        mx-auto
        z-10
      "
      style={{
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
      }}
    >
      {/* Botón abrir modal */}
      <button
        onClick={openModal}
        className="primary text-white px-4 py-2 rounded mb-6"
      >
        Cargar imagen de banner
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={closeModal}
        >
          <div
            className="container-bg p-6 rounded shadow-lg w-full max-w-md"
            onClick={(e) => e.stopPropagation()}
          >
            <form
              onSubmit={handleSubmit}
              className="flex flex-col gap-4 text-white font-semibold"
            >
              {/* Nombre */}
              <div className="flex flex-col">
                <label className="mb-1">
                  Nombre del Banner:
                </label>

                <input
                  type="text"
                  value={bannerName}
                  onChange={(e) =>
                    setBannerName(e.target.value)
                  }
                  required
                  className="
                    p-2
                    rounded
                    bg-[rgba(59,105,233,0.7)]
                    border
                    border-white
                    text-white
                    focus:outline-none
                    focus:ring-2
                    focus:ring-blue-400
                  "
                />
              </div>

              {/* Upload Cloudinary */}
              <div>
                {/* <button
                  type="button"
                  onClick={handleImageUpload}
                  className="
                    bg-green-600
                    hover:bg-green-700
                    text-white
                    px-4
                    py-2
                    rounded
                  "
                >
                  Cargar Imagen
                </button> */}

                {imageUrl && (
                  <p className="mt-2 text-green-400 font-semibold">
                    ✅ Imagen cargada exitosamente
                  </p>
                )}
              </div>

              {/* URL manual */}
              <div className="flex flex-col">
                <label className="mb-1">
                  URL de Imagen:
                </label>

                <input
                  type="text"
                  value={imageUrlInput}
                  onChange={(e) =>
                    setImageUrlInput(e.target.value)
                  }
                  placeholder="https://ejemplo.com/imagen.jpg"
                  className="
                    p-2
                    rounded
                    bg-[rgba(59,105,233,0.7)]
                    border
                    border-white
                    text-black
                    focus:outline-none
                    focus:ring-2
                    focus:ring-blue-400
                  "
                />
              </div>

              {/* Tipo banner */}
              <div className="flex flex-col">
                <label className="mb-1">
                  Tipo de Banner:
                </label>

                <select
                  value={isStatic ? 'true' : 'false'}
                  onChange={(e) => {
                    const value =
                      e.target.value === 'true';

                
                    setIsStatic(value);
                  }}
                  className="
                    p-2
                    rounded
                    bg-[rgba(59,105,233,0.7)]
                    border
                    border-white
                    text-white
                    focus:outline-none
                    focus:ring-2
                    focus:ring-blue-400
                  "
                >
                  <option value="false">
                    Banner dinámico
                  </option>

                  <option value="true">
                    Banner estático
                  </option>
                </select>
              </div>

              {/* Botones */}
              <div className="flex gap-4 justify-end">
                <button
                  type="submit"
                  className="
                    secondary
                    text-white
                    px-4
                    py-2
                    rounded
                  "
                >
                  Enviar
                </button>

                <button
                  type="button"
                  onClick={closeModal}
                  className="
                    secondary
                    text-white
                    px-4
                    py-2
                    rounded
                  "
                >
                  Cerrar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Lista banners */}
      <div>
        <div className="flex flex-wrap justify-center gap-6 mb-6">
          {getCurrentPageBanners().map((banner, index) => (
            <div
              key={index}
              className="
                container-bg
                rounded
                shadow
                p-3
                flex
                flex-col
                items-center
                text-white
                w-60
              "
            >
              <img
                src={banner.url}
                alt={banner.name}
                className="
                  w-full
                  h-32
                  object-cover
                  rounded
                  mb-2
                "
              />

              <span className="font-semibold mb-2 text-center">
                {banner.name}
              </span>

              <span
                className={`text-sm font-semibold mb-2 ${banner.static
                    ? 'text-green-400'
                    : 'text-yellow-400'
                  }`}
              >
                {banner.static
                  ? 'Estático'
                  : 'Dinámico'}
              </span>

              <button
                onClick={() =>
                  handleDelete(banner.name, banner.static)
                }
                className="
                  secondary
                  text-white
                  px-3
                  py-1
                  rounded
                "
              >
                Eliminar
              </button>
            </div>
          ))}
        </div>

        {/* Paginación */}
        <div className="flex justify-center items-center gap-4 text-white">
          <button
            onClick={() =>
              changePage(currentPage - 1)
            }
            disabled={currentPage === 1}
            className={`px-4 py-2 rounded-full ${currentPage === 1
                ? 'secondary'
                : 'primary'
              }`}
          >
            Anterior
          </button>

          {totalPages > 0 ? (
            <span>
              Página {currentPage} de {totalPages}
            </span>
          ) : (
            <span>Cargando...</span>
          )}

          <button
            onClick={() =>
              changePage(currentPage + 1)
            }
            disabled={
              currentPage === totalPages ||
              totalPages === 0
            }
            className={`px-4 py-2 rounded-full ${currentPage === totalPages ||
                totalPages === 0
                ? 'secondary'
                : 'primary'
              }`}
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
};

export default Banner;
